<template>
    <div>
        <!--<div class="row" v-for="(guardian, index) in guardians" :key="guardian.id" v-if="isNewRow(index)">-->
        <!--</div>-->
        <b-form>
            <div class="row" v-for="(guardian, index) in guardians" :key="guardian.id" v-if="isNewRow(index)">
                <div class="col-12 col-sm-6">
                    <guardian-component :firstname="guardian.firstname"
                                        :lastname="guardian.lastname"
                                        :address="guardian.address"
                                        :extraAddressLine="guardian.extraAddressLine"
                                        :zipcode="guardian.zipcode"
                                        :city="guardian.city"
                                        :email="guardian.email"
                                        :mobile="guardian.mobile"
                                        :phone="guardian.phone"
                                        :website="guardian.website">
                    </guardian-component>
                    <div class="row">
                        <div class="col delete-guardian-link">
                            <a href="javascript:void(0)" v-on:click="deleteGuardianDialog(guardian.id)">
                                <icon name="trash-o"></icon>
                                {{$t('guardians.deleteButton')}}
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <guardian-component v-if="index < guardians.length-1"
                                        :firstname="guardians[index+1].firstname"
                                        :lastname="guardians[index+1].lastname"
                                        :address="guardians[index+1].address"
                                        :extraAddressLine="guardians[index+1].extraAddressLine"
                                        :zipcode="guardians[index+1].zipcode"
                                        :city="guardians[index+1].city"
                                        :email="guardians[index+1].email"
                                        :mobile="guardians[index+1].mobile"
                                        :phone="guardians[index+1].phone"
                                        :website="guardians[index+1].website">
                    </guardian-component>
                    <div class="row" v-if="index < guardians.length-1">
                        <div class="col delete-guardian-link">
                            <a href="javascript:void(0)" v-on:click="deleteGuardianDialog(guardians[index+1].id)">
                                <icon name="trash-o"></icon>
                                {{$t('guardians.deleteButton')}}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </b-form>
        <div class="row">
            <div class="col">
                <div class="add-guardian-link">
                    <a href="javascript:void(0)" v-b-modal.add-guardian-modal>
                        {{$t('guardians.addGuardianButton')}}
                    </a>
                </div>
            </div>
        </div>
        <b-modal id="add-guardian-modal" ref="add-guardian-modal"
                 ok-title="Speichern"
                 cancel-title="Abbrechen"
                 :hide-header=true
                 :hide-footer=true>
            <add-guardian-component></add-guardian-component>
        </b-modal>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import {
        GUARDIANS_ACTION_DELETE_GUARDIAN,
        GUARDIANS_ACTION_GET_GUARDIANS,
        GUARDIANS_GETTER,
        GUARDIANS_NAMESPACE
    } from '../../store/modules/guardians-types'
    import GuardianComponent from './GuardianComponent'
    import AddGuardianComponent from './AddGuardianComponent'
    import GuardianAllInfoComponent from './ProtegeAllInfoComponent'
    import 'vue-awesome/icons/trash-o'
    import Icon from 'vue-awesome/components/Icon'
    import i18n from '../../assets/i18n/lang'
    import Vue from 'vue'

    export default {
        name: 'Guardians',
        metaInfo () { return { title: i18n.t('guardians.meta') } },
        components: {
            'guardian-component': GuardianComponent,
            'add-guardian-component': AddGuardianComponent,
            'guardian-all-info-component': GuardianAllInfoComponent,
            'icon': Icon
        },
        computed: {
            ...mapGetters(GUARDIANS_NAMESPACE, {
                guardians: GUARDIANS_GETTER
            })
        },
        methods: {
            ...mapActions(GUARDIANS_NAMESPACE, {
                loadGuardians: GUARDIANS_ACTION_GET_GUARDIANS,
                deleteGuardian: GUARDIANS_ACTION_DELETE_GUARDIAN
            }),
            isNewRow: function (index) {
                if (index % 2 === 0) return true
                else return false
            },
            deleteGuardianDialog (index) {
                Vue.swal({
                    title: 'Bist du sicher?',
                    text: 'Dies kann nicht rückgängig gemacht werden!',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonClass: 'swal-confirm-button',
                    cancelButtonText: 'Abbrechen',
                    cancelButtonClass: 'swal-cancel-button',
                    confirmButtonText: 'Ja, Guardian löschen!',
                    buttonsStyling: false
                }).then((result) => {
                    if (result.value) {
                        this.deleteGuardian(index)
                    }
                })
            }
        },
        created () {
            this.loadGuardians()
        }
    }
</script>

<style lang="scss" scoped>
    .add-guardian-link {
        padding-top: 40px;
        text-align: right;
        text-decoration: underline;
    }

    .delete-guardian-link {
        text-align: left;
        text-decoration: underline;
    }

</style>



// WEBPACK FOOTER //
// src/components/guardian/GuardiansComponent.vue